import { getThemeColors } from '../../utils/chartTheme';

export const getOptions = () => {
    const tc = getThemeColors();
    return {
        maintainAspectRatio: true,
        responsive: true,
        plugins: {
            tooltip: {
                backgroundColor: 'rgba(33, 37, 41, 0.92)',
                titleColor: '#e4e6ea',
                bodyColor: '#e4e6ea',
                padding: 10,
                cornerRadius: 8,
                displayColors: false,
                callbacks: {
                    label: function (context) {
                        let value = context.dataset.data[context.dataIndex];
                        const spezifisch = Math.round((value / 27.5) * 100) / 100;
                        return [
                            '  Tagesertrag: ' + Math.round(value) + ' kWh',
                            '  Spezifisch:  ' + spezifisch + ' kWh/kWp'
                        ];
                    }
                }
            },
            legend: { display: false },
            datalabels: {
                // GRUNDREGEL: Datalabels auf ALLEN Punkten sichtbar
                anchor: 'end',
                align: 'top',
                color: tc.textColor,
                font: { weight: '600', size: 11 },
                formatter: (val) => Math.round(val),
            }
        },
        scales: {
            x: {
                grid: { color: tc.gridColor, drawBorder: false },
                ticks: {
                    autoSkip: false,
                    maxRotation: 45,
                    minRotation: 45,
                    color: tc.textColor
                },
                title: {
                    display: true,
                    text: 'Tag',
                    color: tc.textColor
                }
            },
            y: {
                grid: { color: tc.gridColor, drawBorder: false },
                ticks: {
                    beginAtZero: true,
                    color: tc.textColor,
                    callback: (v) => v + ' kWh'
                },
                title: {
                    display: true,
                    text: 'kWh',
                    color: tc.textColor
                }
            }
        }
    };
};
